import { render, staticRenderFns } from "./VoidBill.vue?vue&type=template&id=6c5ff9e4&scoped=true&"
import script from "./VoidBill.vue?vue&type=script&lang=js&"
export * from "./VoidBill.vue?vue&type=script&lang=js&"
import style0 from "./VoidBill.vue?vue&type=style&index=0&id=6c5ff9e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5ff9e4",
  null
  
)

export default component.exports